import { FC, memo, ReactNode } from 'react';
import {
  Grow,
  ClickAwayListener,
  PopperPlacementType,
} from '@material-ui/core';

import {
  Paper,
  Content,
  Title,
  Header,
  Popper as UIPopper,
  Button,
  Filters,
} from './popper.styles';
import { OnClose } from '../template.types';

interface CommonProps {
  title: string;
  titleHelper: ReactNode;
  onClose: OnClose;
}

interface Props extends CommonProps {
  children: React.ReactNode;
  open: boolean;
  placement: PopperPlacementType;
  anchorEl: HTMLDivElement | null;
}

interface RenderContentArgs extends CommonProps {
  children: React.ReactNode;
}

type RenderContent = (args: RenderContentArgs) => JSX.Element;

const renderContent: RenderContent = ({
  title,
  titleHelper,
  children,
  onClose,
}) => (
  <Content>
    {/* <Header>
      <Title variant="h3">{title}</Title>
      {titleHelper && titleHelper}
    </Header> */}
    <Filters>{children}</Filters>
    {/* <Button className="filDne" fullWidth variant="contained" color="primary" onClick={onClose}>
      Done 
    </Button> */}
  </Content>
);

export const Popper: FC<Props> = memo(
  ({ title, titleHelper, open, anchorEl, children, placement, onClose }) => (
    <UIPopper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      disablePortal
      placement={placement}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: 'top left',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={onClose}>
              {renderContent({ title, titleHelper, children, onClose })}
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </UIPopper>
  )
);
